import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { RefreshIcon } from 'components/icons';
import Button from 'components/shared/Button';
import styles from './UpdateButton.module.css';

const UpdateButton = forwardRef(function UpdateButton(
  { className, disabled, updating, children, ...rest },
  forwardedRef
) {
  return (
    <Button
      ref={forwardedRef}
      size="x-small"
      className={classNames(styles.root, className)}
      disabled={disabled || updating}
      end={
        <RefreshIcon
          className={classNames(styles.icon, {
            [styles.idle]: !updating
          })}
        />
      }
      {...rest}
    >
      {children}
    </Button>
  );
});

export default UpdateButton;
